/**
 * MODULE: _shared/frontend-shell/src/features/crm/utils/formatCurrency.ts
 * PURPOSE: Single CRM amount formatter — delegates to shared Intl helper with workspace defaults
 * DEPENDENCIES: @shared/lib/frontend/utils/formatCurrency (DEFAULT_CRM_CURRENCY, DEFAULT_CRM_LOCALE, formatCurrency)
 * PUBLIC_API: formatCrmCurrency
 * SIDE_EFFECTS: None
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: 35/150
 * RECENT: 2026-05-11 [2.2.943] — Shared defaults **`GBP`** + **`en-GB`** so CRM amounts align on **£** — root **`CHANGELOG` [2.2.943]`**
 * RECENT_PRIOR: 2026-05-08 — **`formatCrmCurrency`** single entry point for CRM amounts (KPI, tables, drawers; tenant defaults from **`CrmContext`**) — shell **`CHANGELOG`** CRM currency note with **[2.2.882]** roll-up.
 */

import {
  DEFAULT_CRM_CURRENCY,
  DEFAULT_CRM_LOCALE,
  formatCurrency,
} from '@shared/lib/frontend/utils/formatCurrency';

/**
 * Format a CRM monetary amount with zero fraction digits.
 * Omit `currency` / `locale` to use the same defaults as `CrmProvider` tenant display (shared constants).
 */
export function formatCrmCurrency(
  amount: number,
  currency: string = DEFAULT_CRM_CURRENCY,
  locale: string = DEFAULT_CRM_LOCALE
): string {
  return formatCurrency(amount, {
    currency,
    locale,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

export { DEFAULT_CRM_CURRENCY, DEFAULT_CRM_LOCALE } from '@shared/lib/frontend/utils/formatCurrency';
